var map = {
	"./bike-green.svg": 421,
	"./bike.svg": 422,
	"./coins.svg": 423,
	"./coins_red.svg": 424,
	"./employee.svg": 425,
	"./microchip-green.svg": 426,
	"./microchip.svg": 427,
	"./mobile phone.svg": 428,
	"./mobile-phone-green.svg": 429,
	"./resource_purple.svg": 430,
	"./resource_red.svg": 431,
	"./resource_white.svg": 432,
	"./resource_yellow.svg": 433,
	"./trophy.svg": 434,
	"./victory_points.svg": 435
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 272;



//////////////////
// WEBPACK FOOTER
// ./app/assets/images/business-model/resource-icons nonrecursive ./~/raw-loader!\.svg$
// module id = 272
// module chunks = 2 5